<template>
  <div class="search-skeleton pulse">
    <div class="title" />
    <div class="skeleton-card"></div>
    <div class="skeleton-card"></div>
    <div class="skeleton-card"></div>
    <div class="skeleton-card"></div>
    <div class="skeleton-card"></div>
  </div>
</template>

<script>
export default {
  name: 'SearchSkeleton',
};
</script>

<style lang="scss" scoped>
.search-skeleton {
  width: 100%;
  height: 100%;

  .title {
    height: 24px;
    width: 70%;
    border-radius: 8px;
    background-color: rgba(254, 254, 254, 0.32);
    margin-bottom: 16px;
  }

  .skeleton-card {
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 122px;
    background-color: rgba(22, 22, 22, 0.08);
    margin: 8px 0;
    padding: 18px 16px;

  }
}

.pulse * {
  animation: pulse 1s infinite ease-in-out;
}

@keyframes pulse {
  0% {
    background-color: rgba(165, 165, 165, 0.1);
  }
  50% {
    background-color: rgba(165, 165, 165, 0.3);
  }
  100% {
    background-color: rgba(165, 165, 165, 0.1);
  }
}

</style>
